import React from 'react';

export default function Contact() {
  return (
    <div className="slide contact fluid">
      <div className="container">
        {/* <h2>Get in touch</h2> */}
        <ol>
          <li className="link">
            <a target="_blank" rel="noopener noreferrer" href="https://github.com/mattgoucher">
              GitHub
            </a>
          </li>
          <li className="link">
            <a target="_blank" rel="noopener noreferrer" href="https://twitter.com/matt_goucher">
              Twitter
            </a>
          </li>
          <li className="link">
            <a target="_blank" rel="noopener noreferrer" href="https://linkedin.com/in/mattgoucher">
              LinkedIn
            </a>
          </li>
        </ol>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Contact.jsx